var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLocalFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg-share-file-a",
    d: "M9 16h6v-6h4l-7-7-7 7h4v6Zm-4 2h14v2H5v-2Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 43,
    x: 1,
    y: 1,
    stroke: "var(--svg-bg-color)",
    strokeOpacity: "var(--svg-bg-opacity)",
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "svg-share-file-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-share-file-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    mask: "url(#svg-share-file-b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13-13h50v50h-50Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLocalFile);
export default __webpack_public_path__ + "static/media/share-local-file.65fff216634723add6d6fffbc6ac7ac8.svg";
export { ForwardRef as ReactComponent };